import { ReducerStateContant } from "../constants/general-const";
import { getLocalStore, clearLocalStore } from '../../localStorage/index';
function Completed(stateObject) {
  if (stateObject && stateObject.apiMsg && stateObject.apiMsg.status && stateObject.apiMsg.status === ReducerStateContant.fulfilled) {
    return true;
  }
  else {
    return false;
  }
}
function NotInitate(stateObject) {
  if (stateObject.apiMsg == null) {
    return true;
  }
  else if (stateObject.apiMsg && stateObject.apiMsg.status == null) {
    return true;
  }
  else {
    return false;
  }
}
function Pending(stateObject) {
  if (stateObject && stateObject.apiMsg && stateObject.apiMsg.status === ReducerStateContant.pending) {
    return true;
  }
  else {
    return false;
  }
}
function Rejected(stateObject) {
  if (stateObject && stateObject.apiMsg && stateObject.apiMsg.status === ReducerStateContant.rejected) {
    return true;
  }
  else {
    return false;
  }
}
function Records(obj) {
  // console.log( "has record length",obj.data.records)
  if (obj && obj.data && obj.data.records && obj.data.records.length) {

    return true;
  }
  else {
    return false;
  }
}
function HasData(obj) {
  // console.log( "has record length",obj.data.records)
  if (obj && obj.data) {

    return true;
  }
  else {
    return false;
  }
}
function GetMappedDataSourceForSelect(dataSoruce, valueKey, labelKey, viewAll) {
  var selectSource = [];
  if (dataSoruce && dataSoruce.length) {
    if (viewAll) {
      selectSource.push({ value: 'all', label: 'View All' })
    }
    dataSoruce.map((r) => {
      selectSource.push({
        value: r[valueKey],
        label: r[labelKey]
      })
    })
  }

  return selectSource;
}

function CreateArrayOfNumbers(minValue, maxValues) {

  return [...Array((maxValues + 1) - minValue).keys()].map((i) => {
    return (minValue + i)
  });
}

function getPermittedMenus(menuList, permissionList) {
  const filterMenu = (list, permissionList) => {
    return list.filter((menus) => {
      if (
        menus.HasSubMenu === false &&
        permissionList.some(
          (permission) => permission.pageName === menus.MenuId
        )
      ) {
        return true;
      } else if (
        menus.HasSubMenu === true &&
        menus.SubMenu &&
        menus.SubMenu.length
      ) {
        menus.SubMenu = filterMenu(menus.SubMenu, permissionList);
        // console.log(menu.SubMenu,'menu.submenu');
        return menus.SubMenu.length > 0;
      }
      return false;
    });
  };
  return filterMenu(menuList, permissionList);
}

function allowViewMenu(menu) {

  let permissionList = getLocalStore(process.env.REACT_APP_LOCAL_STORAGE_KEY_USER)?.permissions;

  let filteredPermissions = permissionList && permissionList.length ? permissionList.filter(permission => permission.isView === true) : null;
  if (menu) {
    const isMenuViewAllowed = filteredPermissions && filteredPermissions.length ? filteredPermissions.some((listmenu) => listmenu.pageName.toLowerCase() === menu.toLowerCase()) : null;
    if (isMenuViewAllowed) {
      return true;
    } else {
      return false;
    }
  }
  else {
    return true;
  }



}

function allowModifyMenus(menu) {
  let permissionList = getLocalStore(process.env.REACT_APP_LOCAL_STORAGE_KEY_USER)?.permissions;

  let filteredPermissions = permissionList && permissionList.length ? permissionList.filter(permission => permission.isModify === true) : null;

  const isMenuAllowed = filteredPermissions && filteredPermissions.length ? filteredPermissions.some((listmenu) => listmenu.pageName === menu) : null;

  if (isMenuAllowed) {
    return true;
  } else {
    return false;
  }

}

function allowDeleteMenus(menu) {
  let permissionList = getLocalStore(process.env.REACT_APP_LOCAL_STORAGE_KEY_USER)?.permissions;

  let filteredPermissions = permissionList && permissionList.length ? permissionList.filter(permission => permission.isDelete === true) : null;

  const isMenuAllowed = filteredPermissions && filteredPermissions.length ? filteredPermissions.some((listmenu) => listmenu.pageName === menu) : null;

  if (isMenuAllowed) {
    return true;
  } else {
    return false;
  }

}
export { Completed, NotInitate, Pending, Rejected, Records, HasData, GetMappedDataSourceForSelect, CreateArrayOfNumbers, getPermittedMenus, allowViewMenu, allowModifyMenus, allowDeleteMenus };